// #region

// --- HS Code
import { UpdateCommand } from "../shared/update-command";
import { RespondentModel } from "./respondent-model";

// #endregion

export class RespondentUpdateCommand extends UpdateCommand<RespondentModel> {
  constructor(
    target: RespondentModel,
    commandId: number,
    identifier: string,
    propertyNames: (keyof(RespondentModel))[],
    newValues: any[]
  ) {
    super(target, commandId, identifier, propertyNames, newValues);
  }
}
